import { pluralize } from '@gonfalon/format/pluralize';
import { wasOrWere } from '@gonfalon/strings/wasOrWere';

import type { BulkMemberActionNotification } from './types';

// We need a notification message when the bulk add members flow is complete.
// It's a little tricky to get the right message (based on the various inputs)
// so we have a helper utility to generate it.
const bulkAddMembersSuccessOrErrorMessage = ({
  errorsCount,
  memberCount,
  teamCount,
  warningsCount,
}: BulkMemberActionNotification & { teamCount: number }) => {
  const teamCountText = `${teamCount} ${pluralize(teamCount, 'team', 'teams')}`;

  let successMessage;
  let errorsMessage;

  if (memberCount) {
    const memberCountText = `${memberCount} ${pluralize(memberCount, 'member', 'members')}`;
    const successText = `${memberCountText} ${wasOrWere(memberCount)} added to ${teamCountText}.`;

    if (!warningsCount) {
      // All succeed
      successMessage = successText;
    } else {
      // Some succeed, some fail because they already exist on that team
      const warningsCountText = `${warningsCount} ${pluralize(warningsCount, 'member', 'members')}`;
      const warningsText = `${warningsCountText} ${wasOrWere(warningsCount)} already on ${teamCountText}.`;
      successMessage = `${successText} ${warningsText}`;
    }
  }

  if (errorsCount) {
    // Some fail outright
    const errorsCountText = `${errorsCount} ${pluralize(errorsCount, 'member', 'members')}`;
    errorsMessage = `${errorsCountText} ${wasOrWere(errorsCount)} not added to ${teamCountText}.`;
  }

  return { successMessage, errorsMessage };
};

export { bulkAddMembersSuccessOrErrorMessage };
